<template>
    <div class="min-height" :class="{'integralInfo': hasIntegral}">
        <p class="notice-msg" v-if="!hasIntegral">敬请期待</p>
        <div v-else style="width: 100%">
            <div class="flex-row vertical-center flow-justify" style="width: 100%">
                <p class="info flex-1">会员积分级别：<span>{{integralInfo.memLv == 1 ? '普通会员' : '尊享会员'}}</span></p>
                <p class="info flex-1">可用积分：<span>{{integralInfo.integralBalance}}</span></p>
                <p class="info flex-1" v-if="integralInfo.memLv != 1">会员到期时间：<span>{{integralInfo.expireDate}}</span></p>
            </div>

            <common-el-form :model="model" :submitData="submitData" @success="onSuccess" :SubmitButton="true"
                            :showButton="false" submit-btn-text="保存" failTitle="提交失败" loadingText="提交中..."
                            :hideRequiredAsterisk="true" :submitService="submitService" v-if="levelList.length">
                <p class="info" style="margin-bottom: 0;">商城等级调整</p>
                <el-form-item prop="days">
                    <el-radio-group v-model="model.days">
                        <el-radio :label="item.id" v-for="(item, index) in levelList" :key="index" v-if="item.status == 1">{{item.labelDesc}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </common-el-form>
        </div>
    </div>
</template>

<script>
    import CommonElForm from 'components/common/CommonElForm'
    import MallService from 'service/MallService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "IntegralInfo",
        data() {
            return {
                model: {
                    days: 0,
                },
                integralInfo: {},
                levelList:[],
                submitService: MallService.changeExpiredDate,
                modelRules:{
                    days: [{
                        required: false
                    }]
                }
            }
        },
        components: {
            CommonElForm
        },
        mixins: [loadMixin, dialogMixin],
        created() {
            this.getList();
            this.getIntegralInfo();
        },
        computed: {
            hasIntegral(){
                return this.currentOrgDetail.integralSwitch == 1;
            },
            submitData() {
                const params = {
                    cardId: this.model.days,
                    memId: this.$route.params.id,
                };
                return params;
            },
            ...mapGetters(['userInfo', 'currentOrgDetail'])
        },
        methods: {
            getList() {
                this.doLoad(MallService.tatIntegralCardSetting, '', res => {
                    this.doCheck(res, res => {
                        this.levelList = res.contents;
                        this.model.days = this.levelList[0].id
                    });
                }, '信息获取失败')
            },
            getIntegralInfo() {
                this.doLoad(MallService.memIntegralInfo, {
                    memId: this.$route.params.id
                }, res => {
                    this.doCheck(res, res => {
                        this.integralInfo = res.contents;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.showSuccess(res.contents.optMsg);
                this.model.days = this.levelList[0].id;
                this.getIntegralInfo();
            }
        }
    }
</script>

<style scoped>
    .integralInfo {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .info {
        font-size: 14px;
        color: #000;
        font-weight: bold;
        margin-bottom: 50px;
    }

    .info span {
        font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/IntegralInfo.vue